/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>cui-detail.component.ts</name>
///
/// <description>

/// </description>
///
/// <author>Michael Martinez</author>
/// <created>14 Oct 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 14Oct16 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///
import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter, ContentChild, forwardRef } from '@angular/core';
import { ActivatedRoute, Params, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription'; 
import { HydUser } from "../../models/user";
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { MenuItem, Message } from 'primeng/primeng'; 
import { CUIFeatureInterface } from  '../../interfaces/cui-feature.interface'; 
import { TranslatedStringsService } from '../../services/language.service';
import { MediatorService } from '../../services/mediator.service';
import { MediatorEventLookup } from '../../services/mediator-event-lookup.service';
import { LogService } from '../../services/log.service';
import { PortalVersionService } from '../../services/portal-version.service';

@Component({
    selector: 'cui-detail',
    templateUrl: './cui-detail.component.html',
    styleUrls: ['./cui-detail.component.css']
})

export class CUIDetailComponent implements CUIFeatureInterface {

    @Input() location: MenuItem[];
    @Input() actions: MenuItem[];
    @Input() model: any;
    @Input() subscriptions: Subscription[];
    @Input() notifications: Message[];
    @Input() edit: boolean = false;
    @Output() onTitleChange = new EventEmitter();
    @Output() onActionsClick = new EventEmitter();
    @Input() hideMenu: boolean = false;
    @ContentChild(forwardRef(() => CUIDetailHeader)) headerFacet;
    @Input() breadcrumbClass: boolean = false;
    @Input() actionsBtnLbl: string;

    private i18nInitialized: boolean = false;
    private changes: any;
    private busyLoading: any;
    private revertName: string;
    private titleContentActive: boolean;
    private userActionNotification: Subscription;
    private routeChangeSubscription: Subscription;
    private lblActions: string;
    private lblCloudwareLicense: string;
    private lblServiceStatus: string;
    private lblPrivacyStatement: string;
    private portalVersion: string;
     

    constructor(
        private i18n: TranslatedStringsService, private mediator: MediatorService, private log: LogService, private router: Router, private portalVersionService: PortalVersionService )
    { }

    //----------------------------------------------------------
    //Implementations of Interface
    //----------------------------------------------------------
    ngOnChanges(changes: any) {
        if (this.actionsBtnLbl == null || this.actionsBtnLbl == "") {
            this.actionsBtnLbl = this.lblActions;
        }

        this.changes = changes;

        if (this.i18nInitialized) {

            if (changes.subscriptions) {
                this.UpdateBusyControl();
            }
            if (changes.model && this.model && this.model.name) {
                this.revertName = this.model.name;
            }

            if (this.model && this.revertName === this.model.name) {
                this.titleContentActive = false;
            }
        }
    };

    ngDoCheck() { };
    ngAfterContentInit() { };
    ngAfterContentChecked() { };
    ngAfterViewInit() { };
    ngAfterViewChecked() { };
    ngOnDestroy() {
        if (this.userActionNotification) {
            this.userActionNotification.unsubscribe();
        }
        if (this.routeChangeSubscription)
            this.routeChangeSubscription.unsubscribe();
    };

    //----------------------------------------------------------
    //ngOnInit
    //----------------------------------------------------------
    ngOnInit() {

        this.translate();
        this.getPortalVersion();

        if (this.actionsBtnLbl == null || this.actionsBtnLbl == "") {
            this.actionsBtnLbl = this.lblActions;
        }

        if (this.model && this.model.name) {
            this.revertName = this.model.name;
        }

        this.subscribeToUserActionNotification();
        this.subscribeToDetailFormChangedEvent();
        this.subscribeToRouteChange();  
    }

    //-----------------------------------------------
    // subscribeToRouteChange
    //-----------------------------------------------
    private subscribeToRouteChange() {

        this.routeChangeSubscription = this.router.events.subscribe((val) => {

            if (val instanceof NavigationEnd) {
                this.actionsBtnLbl = this.lblActions;
            }
        });
    }

    private subscribeToDetailFormChangedEvent() {
        this.mediator.Event(MediatorEventLookup.DetailFormChanged).subscribe(
            data => {
                this.actionsBtnLbl = data;
                this.changeActionsItemsState(false);
            }
        );
    }

    private translate() {
    
            this.i18nInitialized = true;
            this.ngOnChanges(this.changes);

            this.lblActions = this.i18n.translate("account-action");
            this.lblCloudwareLicense = this.i18n.translate("cloudware-license");
            this.lblServiceStatus = this.i18n.translate("service-status");
            this.lblPrivacyStatement = this.i18n.translate("privacy-statement");
       
    }

    //----------------------------------------------------------
    //handleKeydown
    //----------------------------------------------------------
    private handleKeydown(event) {

        //On ENTER key down
        if (event.keyCode == 13)
            this.handleTitleChangeOK(event);
        //On ESCAPE key down
        else if (event.keyCode === 27)
            this.handleTitleChangeCancel(event);
    }

    //----------------------------------------------------------
    //handleOnActivateTitle
    //----------------------------------------------------------
    private handleOnActivateTitle(event) {

        this.titleContentActive = true;
    }

    //----------------------------------------------------------
    //handleTitleChangeOK
    //----------------------------------------------------------
    private handleTitleChangeOK(event) {

        this.onTitleChange.emit(event);
        this.titleContentActive = false;
    }

    private handleActionsBtnSave(event) {
        if (this.actionsBtnLbl == this.i18n.translate("form-save-changes")) {
            this.onActionsClick.emit(event);
        }   

        this.actionsBtnLbl = this.lblActions;

        this.changeActionsItemsState(true);
    }

    private changeActionsItemsState(isDisabled: boolean) {
        let instance = this;
        _.each(this.actions, function (item) {
            if (item.label == instance.i18n.translate("form-save-changes") || item.label == instance.i18n.translate("form-revert")) {
                item.disabled = isDisabled;
            }
        });
    }

    //----------------------------------------------------------
    //handleTitleChangeCancel
    //----------------------------------------------------------
    private handleTitleChangeCancel(event) {

        this.model.name = this.revertName;
        this.titleContentActive = false;
    }

    //----------------------------------------------------------
    //ngOnDestroyUpdateBusyControl
    //----------------------------------------------------------
    UpdateBusyControl() {

        if (this.subscriptions && this.subscriptions.length > 0) {
            let delay: number = 100;
            let minDuration: number = 900;

            this.busyLoading = {
                busy: this.subscriptions,
                message: this.i18n.translate("busy-loading"),
                delay: delay,
                minDuration: minDuration
            };
        }
    }

    private subscribeToUserActionNotification(): void {
        this.userActionNotification = this.mediator.Event(MediatorEventLookup.HttpErrorEvent).subscribe(
            (payload: Message) => {
                if (payload.detail && payload.detail === this.i18n.translate('devicerename-namealreadyexist')) {
                    //Do nothing
                }
                else{
                    payload.summary = this.i18n.translate("http-error-message");
                    //YH 4/5/2017 add correlation id to http error messages
                    if (payload.detail)
                        payload.detail = this.i18n.translate("http-error-correlationid") + payload.detail;
              
                }
                this.notifications = [];
                this.notifications.push(payload);
            },
            err => this.log.logMessage(err),
            () => { }
        );
    }

    private getPortalVersion() {
        this.portalVersionService.getVersion()
            .subscribe(res => {
                this.portalVersion = res.portalVersionNumber;
            });
    }
}

@Component({
    selector: 'cui-detail-header',
    template: `
        <span class="cui-detail-header">
            <ng-content></ng-content>
        </span>
    `
})
export class CUIDetailHeader { }



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-detail/cui-detail.component.ts